import { Text } from "@asayinc/component-library";
import { Box, Stack } from "@mui/material";
import dayjs from "dayjs";
import { useParams } from "react-router-dom";

import { Card } from "src/components/atoms/Card";
import { ErrorState } from "src/components/atoms/ErrorState";
import { ScrollContainer } from "src/components/containers/ScrollContainer";
import { LabelField } from "src/components/molecules/LabelField";
import {
  LoadingCard,
  LoadingStatsHeaderCard,
} from "src/components/molecules/Loading";
import { useClassActionEventQuery } from "src/store/classActionEvent";

export function ClassActionEventDetailsTab() {
  const { id } = useParams() as { id: string };
  const {
    data: classActionEvent,
    isLoading,
    error,
  } = useClassActionEventQuery({ id });
  if (error || (!isLoading && !classActionEvent)) {
    return <ErrorState />;
  }

  if (isLoading) {
    return (
      <ScrollContainer sx={{ pt: 8, pb: 10, pl: 10, pr: 6.25 }}>
        <LoadingStatsHeaderCard />
        <Box sx={{ display: "flex", mt: 8 }}>
          <Box sx={{ flexGrow: 1, flexBasis: 0, mr: 12 }}>
            <LoadingCard />
          </Box>
          <Box sx={{ flexGrow: 1, flexBasis: 0 }}>
            <LoadingCard />
          </Box>
        </Box>
      </ScrollContainer>
    );
  }

  const {
    securities,
    recordDateStart,
    recordDateEnd,
    jobNumber,
    claimsAdministrator,
    litigationWebsite,
    sourceProviderCaseDeadline,
  } = classActionEvent;

  return (
    <ScrollContainer sx={{ pt: 8, pb: 10, pl: 10, pr: 6.25 }}>
      <Card title="Class Action Event Details">
        <Stack sx={{ mt: 6, px: 6 }} direction="row">
          <Box sx={{ width: "25%" }}>
            <Text variant="subtitle1" sx={{ mb: 3 }}>
              Type
            </Text>
            {/* <Box sx={{ display: "flex", alignItems: "baseline" }}>
              <Text variant="h5">{CLASS_ACTION_EVENT_LABEL[type]}</Text>
            </Box> */}
          </Box>
          <Box sx={{ width: "25%" }}>
            <Text variant="subtitle1" sx={{ mb: 3 }}>
              CUSIPs
            </Text>
            <Text variant="h5">
              {securities.map((security) => security.cusip).join(", ")}
            </Text>
          </Box>
          <Box sx={{ width: "25%" }}>
            <Text variant="subtitle1" sx={{ mb: 3 }}>
              Record Date Start
            </Text>
            <Box sx={{ display: "flex", alignItems: "baseline" }}>
              <Text variant="h5">
                {dayjs(recordDateStart).format("MM/DD/YYYY")}
              </Text>
            </Box>
          </Box>
          <Box sx={{ width: "25%" }}>
            <Text variant="subtitle1" sx={{ mb: 3 }}>
              Record Date End
            </Text>
            <Box sx={{ display: "flex", alignItems: "baseline" }}>
              <Text variant="h5">
                {dayjs(recordDateEnd).format("MM/DD/YYYY")}
              </Text>
            </Box>
          </Box>
          <Box sx={{ width: "25%" }}>
            <Text variant="subtitle1" sx={{ mb: 3 }}>
              Job Number
            </Text>
            <Text variant="h5">{jobNumber || "-"}</Text>
          </Box>
        </Stack>
      </Card>
      <Box sx={{ display: "flex", mt: 8 }}>
        <Box sx={{ flexGrow: 1, flexBasis: 0, mr: 12 }}>
          <Card title="Case information">
            <LabelField
              sx={{
                py: 5,
                px: 4,
                borderBottom: "1px solid #e0e0e0",
                fontWeight: 600,
              }}
              isLabelBold={true}
              label="Case Claim Deadline"
              value={dayjs(sourceProviderCaseDeadline).format(
                "MMMM DD, YYYY hh:mma"
              )}
            />
            <LabelField
              sx={{
                py: 5,
                px: 4,
                borderBottom: "1px solid #e0e0e0",
                fontWeight: 600,
              }}
              isLabelBold={true}
              label="Litigation Website"
              value={litigationWebsite || "-"}
            />
          </Card>
        </Box>
        <Box sx={{ flexGrow: 1, flexBasis: 0 }}>
          <Card title="Intermediaries">
            <LabelField
              sx={{
                py: 5,
                px: 4,
                borderBottom: "1px solid #e0e0e0",
              }}
              label="Claims Administrator"
              isLabelBold={true}
              value={claimsAdministrator.name}
            />
          </Card>
        </Box>
      </Box>
    </ScrollContainer>
  );
}
